import { useEffect, useState } from 'react';

import { getPayPeriodCountdown, isUserGracePeriod, PayPeriodCountdown } from 'src/utils/engagementTimeSheets';
import useUsers from 'src/hooks/useUsers';
import usePayPeriods from 'src/hooks/usePayPeriods';

const usePayPeriodCountdownTimer = (payPeriodDate: Date): PayPeriodCountdown | null => {
  const [today, setToday] = useState<Date>(new Date());

  const { currentUser } = useUsers();
  const { currentPeriod, previousPeriod, weeklyPayPeriodsStartDate } = usePayPeriods();

  useEffect(() => {
    const handlePageVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setToday(new Date());
      }
    };

    document.addEventListener('visibilitychange', handlePageVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handlePageVisibilityChange);
    };
  }, []);

  useEffect(() => {
    setToday(new Date());
  }, [currentPeriod?.id]);

  if (!currentPeriod || !weeklyPayPeriodsStartDate) return null;

  return getPayPeriodCountdown({
    now: today,
    payPeriodDate,
    currentPeriod,
    previousPeriod,
    isGracePeriod: isUserGracePeriod(currentUser, currentPeriod, weeklyPayPeriodsStartDate, today),
    weeklyPayPeriodsStartDate,
  });
};

export default usePayPeriodCountdownTimer;
